import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import styles from './RelatedHalal.module.css';

function fmtPct(n) {
  if (!n && n !== 0) return '';
  const pct = Math.abs(n) < 2 ? n * 100 : n;
  return (pct >= 0 ? '+' : '') + pct.toFixed(2) + '%';
}

export default function RelatedHalal({ currentTicker, sector, onScreen }) {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get('/api/trending')
      .then(({ data }) => {
        const all = data.results || [];
        // Same sector first, then others — exclude current ticker, cap at 6
        const sameSector = all.filter(
          s => s.symbol !== currentTicker &&
               sector && s.sector &&
               s.sector.toLowerCase() === sector.toLowerCase()
        );
        const others = all.filter(
          s => s.symbol !== currentTicker && !sameSector.includes(s)
        );
        setItems([...sameSector, ...others].slice(0, 6));
      })
      .catch(() => setItems([]));
  }, [currentTicker, sector]);

  if (!items.length) return null;

  return (
    <div className={styles.wrap}>
      <h3 className={styles.title}>{t('related_halal.title')}</h3>
      <div className={styles.grid}>
        {items.map(s => {
          const pct = Math.abs(s.changePct) < 2 ? s.changePct * 100 : s.changePct;
          const up  = pct >= 0;
          return (
            <button
              key={s.symbol}
              className={styles.card}
              onClick={() => onScreen(s.symbol)}
            >
              <div className={styles.cardTop}>
                <span className={styles.symbol}>{s.symbol}</span>
                {s.quoteType === 'ETF' && <span className={styles.etfTag}>{t('related_halal.etf_tag')}</span>}
                <span className={`${styles.pct} ${up ? styles.up : styles.down}`}>
                  {fmtPct(s.changePct)}
                </span>
              </div>
              <div className={styles.name}>{s.name}</div>
              <div className={styles.sector}>{s.sector !== 'N/A' ? s.sector : ''}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
